<div
  [class]="cardClass"
  (click)="onCardClick()"
  [attr.role]="variant !== 'merchant' ? 'button' : null"
  [attr.tabindex]="variant !== 'merchant' ? '0' : null"
  (keydown.enter)="variant !== 'merchant' && onCardClick()"
  (keydown.space)="variant !== 'merchant' && onCardClick()"
  >
  <!-- Status Badge -->
  <div class="status-badge-container">
    <span [class]="'status-badge ' + statusClass">
      {{ account.status }}
    </span>
  </div>

  <!-- Avatar -->
  <div class="avatar-container">
    <div class="avatar">
      @if (account.avatarUrl) {
        <img [src]="account.avatarUrl" [alt]="account.firstName" class="avatar-image" />
      } @else {
        <span class="avatar-initials">{{ account.initials }}</span>
      }

      <!-- Online Presence Indicator -->
      @if (isOnline) {
        <div class="active-indicator" matTooltip="Online"></div>
      }
    </div>
  </div>

  <!-- Account Information -->
  <div class="account-info">
    <!-- Account Details -->
    <div class="account-details">
      <div class="account-name-container">
        <div class="account-name-container">
          <h3 class="account-name account-first">{{ account.firstName }}</h3>
          <h3 class="account-name account-last">{{ account.lastName }}</h3>
        </div>
      </div>
      <p class="account-position">{{ account.position }}</p>
      <p class="account-role">{{ groupNames }}</p>
    </div>
  </div>
</div>
